<template>
  <svg class="svg">
    <title
      v-if="title"
      v-text="title"
    />
    <desc
      v-if="desc"
      v-text="desc"
    />
    <slot/>
  </svg>
</template>

<script>
  import svg from '@/mixins/svg';

  export default {
    mixins: [svg],
  };
</script>

<style
  scoped
  lang="scss"
>
  .svg {
    width: 100%;
    height: 100%;
  }
</style>
